import { Component, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FaqService } from 'src/app/services/faq.service';
import { TitleService } from 'src/app/services/title.service';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit {

  private componentDestroyed = new Subject();

  faqData!: any;

  constructor(private titleService: TitleService, private faqService: FaqService) {

    this.titleService.setTitle("Finansklagenemnda");

    this.faqService.faqData
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(
        (items: any[]) => {
          this.faqData = items.length > 0 ? items[0] : undefined;
        }
      );



    this.faqService.readFAQData();

  }

  ngOnInit(): void {

  }

}
